import { subscribeToContextChange, getUserDetails } from "../platform-core";

export let interactionId: string | undefined;
export let entityName: string | undefined;

export function subscribeToLoanContext() {
  subscribeToContextChange("loan", {
    onSet: () => {
      setInteractionId();
      setEntityName();
    },
    onUnset: () => {
      clearInteractionId();
      clearEntityName();
    },
  });
}

const setInteractionId = function () {
  interactionId = crypto.randomUUID();
};

const clearInteractionId = function () {
  interactionId = undefined;
};

const setEntityName = function () {
  entityName = getUserDetails().entityName;
};

const clearEntityName = function () {
  entityName = undefined;
};
